// Réglages de notification (lot P 0.5.x — SRF-TRV-049) : préférence PERSONNELLE de l'utilisateur
// courant, lecteur compris. Le niveau agit sur ce qui NOTIFIE (cloche, pastilles, résumé) ;
// « Muet » ne coupe jamais la Boîte d'attention et le fil /notifications reste entier.
// Le résumé est livré dans l'application (notification de nature `digest`) ; l'e-mail est hors périmètre.
import { request } from './http'

/** Adresse du panneau (bouton « Réglages » de /notifications et entrée du menu Compte) : une seule source. */
export const ADRESSE_REGLAGES_NOTIFICATIONS = '/notifications?vue=reglages'

export type NiveauNotification = 'all' | 'mentions' | 'mute'

export const NIVEAUX_NOTIFICATION: readonly NiveauNotification[] = ['all', 'mentions', 'mute']

export interface PreferenceProjet {
  workspace_id: string
  name: string
  /** `null` = hérite du niveau par défaut. */
  level: NiveauNotification | null
}

export interface PreferencesNotification {
  default_level: NiveauNotification
  digest: boolean
  projects: PreferenceProjet[]
  /** Créneaux du résumé, « HH:MM », dans le fuseau `digest_zone` du serveur. */
  digest_slots: string[]
  digest_zone: string
  /** Natures qui notifient encore au niveau « Mentions seulement ». */
  direct_kinds: string[]
}

export interface ModificationPreferences {
  default_level: NiveauNotification
  digest: boolean
  projects: { workspace_id: string; level: NiveauNotification | null }[]
}

export const preferencesNotificationApi = {
  lire: () => request<PreferencesNotification>('/users/me/preferences/notifications'),
  /** Remplace les réglages ; rend la valeur ENREGISTRÉE (celle qu'on affiche ensuite). */
  enregistrer: (m: ModificationPreferences) =>
    request<PreferencesNotification>('/users/me/preferences/notifications', { method: 'PUT', body: JSON.stringify(m) }),
}
